import { render, staticRenderFns } from "./BCKeyAssignmentSuperLock.vue?vue&type=template&id=0594d5c2&scoped=true"
import script from "./BCKeyAssignmentSuperLock.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentSuperLock.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentSuperLock.vue?vue&type=style&index=0&id=0594d5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594d5c2",
  null
  
)

export default component.exports